import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";

//---------------------------------------------------------------


// GET =>  get Ads ForSchool
export const getAdsForSchool = createAsyncThunk(
    "ads/getAdsForSchool",
    async (params, thunkAPI) => {
        try {
            const response = await axios.get(`${URLS.getAdsForSchoolURL}/${params?.school_id}`, {
                params: {
                    page: params.page
                }
            });
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


// Post =>   addNewAdsForSchool
export const addNewAdsForSchool = createAsyncThunk(
    "ads/addNewAdsForSchool",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                URLS.addNewAdsForSchoolURL, data, {
                headers: {
                    Accept: "*/*",
                    "Content-Type": "multipart/form-data",
                },
            });
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

// DELETE =>   addNewAdsForSchool
export const deleteAds = createAsyncThunk(
    "ads/deleteAds",
    async (id, thunkAPI) => {
        try {
            const response = await axios.delete(`${URLS.deleteAdsURL}/${id}`);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

// GET =>  get Ads ForSchool
export const getGlobalAds = createAsyncThunk(
    "ads/getGlobalAds",
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(URLS.getGlobalAdURL);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);
